import './AdditionalOption.css';

const AdditionalOption = ({ icon, title, description, price, quantity, onQuantityChange, link, onReadMore, maxQuantity = 1 }) => {
  const handleLinkClick = (e) => {
    e.preventDefault();
    if (onReadMore) {
      onReadMore();
    }
  };

  return (
    <div className="additional-option">
      <div className="additional-icon">{icon}</div>
      <div className="additional-info">
        <h4>{title}</h4>
        <p>{description}</p>
        {link && (
          <button 
            onClick={handleLinkClick} 
            className="read-more"
          >
            {link.text}
          </button>
        )}
      </div>
      <div className="additional-price">{price}</div>
      <div className="quantity-controls">
        <button 
          onClick={() => onQuantityChange(Math.max(0, quantity - 1))}
          disabled={quantity === 0}
        >
          -
        </button>
        <span>{quantity}</span>
        <button 
          onClick={() => onQuantityChange(quantity + 1)}
          disabled={quantity >= maxQuantity}
        >
          +
        </button>
      </div>
    </div>
  );
};

export default AdditionalOption;
